import { createGet, createPut, createPost, createDelete } from './ajax';
import { createFetch } from './fetch';

export {
  addGuest,
  removeGuest,
  fetchEvent,
  fetchEventDelivery,
  fetchPrice,
  newEvent,
  sendEvent,
  updateEventDetails,
} from './event.js';

export const logUserIn = createPost({
  path: '/api/v1/session',
  allowedParams: ['account', 'remember_me'],
  json: true,
});

export const logUserOut = createDelete({
  path: '/api/v1/session',
});

export const signUp = createPost({
  path: '/api/v1/accounts',
  allowedParams: ['account', 'email_address'],
  json: true,
});

export const fetchAccount = createGet({
  path: '/api/v1/accounts/me',
});

export const fetchNotifications = createGet({
  path: '/api/v1/accounts/current/notifications',
});

export const clearNotifications = createPut({
  path: '/api/v1/accounts/current/notifications',
});

export const fetchFavorites = createGet({
  path: '/api/v1/packages/favorites',
});

export const addFavorite = createPost({
  path: params => `/api/v1/packages/${params.packageId}/favorites`,
});

export const removeFavorite = createDelete({
  path: params => `/api/v1/packages/${params.packageId}/favorites`,
});

const allowedPackageParams = [
  'available_in_paper',
  'card',
  'category',
  'coins',
  'colors',
  'country_code',
  'currency',
  'designers',
  'favorites',
  'group',
  'ids',
  'package_properties',
  'page',
  'per_page',
  'photo_back',
  'photo_count',
  'print_methods',
  'private',
  'private_content',
  'q',
  'sort',
  'filters',
  'section',
  'shape',
  'sort',
  'suite',
  'use_category_popularity_sort',
  'user_agent_mobile',
];

const sanitizeParams = params => {
  // accommodate endpoint with a broken contract. `designers` needs
  // to be an array.
  // @TODO fix endpoint to accept single query params without `[]`
  // https://paperlesspost.atlassian.net/browse/DISCO-2631
  if (params.private && typeof params.designers === 'string') {
    return {
      ...params,
      designers: [params.designers],
    };
  }

  return params;
};

export const fetchPackages = requestedProps =>
  createFetch({
    path: '/packages',
    allowedParams: allowedPackageParams,
    defaultParams: {
      per_page: 28,
    },
    forcedParams: {
      version: 'online',
    },
    requestedProps: sanitizeParams(requestedProps),
  })();

export const fetchFavoritePackages = createGet({
  path: '/packages/favorites',
  allowedParams: allowedPackageParams,
  forcedParams: {
    version: 'online',
    paper_browser: true, // we need this so that we get back a full PB response
    favorites: true, // we need this so we get back the correct title
  },
});

export const fetchSingleCard = requestedProps =>
  createFetch({
    path: `/packages/${requestedProps.cardId}/details`,
    allowedParams: allowedPackageParams,
    requestedProps,
  })();

export const fetchCoinProducts = requestedProps =>
  createFetch({
    path: `/coin_products/coins`,
    allowedParams: ['currency', 'preferred_currency'],
    json: true,
    requestedProps,
  })();

export const emailDesign = createPost({
  path: params => `/api/v1/packages/${params.cardId}/email_design`,
  allowedParams: ['cardId', 'email_address'],
  json: true,
});

export const resetPassword = createPost({
  path: '/api/v1/password_resets',
  allowedParams: ['email_address'],
  json: true,
});

export const fetchLocale = createGet({
  path: '/api/v1/international/me',
});

export const setLocale = createPost({
  path: '/api/v1/international/set_locale',
  allowedParams: ['country_code'],
  json: true,
});
